/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const SEO = ({ description = "", lang = "en", meta = [], title, canonical = "", location, robots = "index", image, ...props }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `,
  )

  const metaDescription = description || site.siteMetadata.description

  let extraMeta = meta
  if (location) {
    extraMeta = extraMeta.concat([
      {
        property: `og:url`,
        content: `${site.siteMetadata.siteUrl}${location.pathname}`,
      },
    ])
  }

  if (image) {
    extraMeta = extraMeta.concat([
      {
        property: `og:image`,
        content: image,
      },
    ])
  }

  const link = [
    {
      rel: "alternate",
      type: "application/rss+xml",
      href: "https://www.mindbodygreen.com/rss/featured.xml",
    },
  ]
  if (canonical) {
    link.push({
      rel: "canonical",
      href: canonical,
    })
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      link={link}
      meta={[
        {
          name: `robots`,
          content: robots,
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(extraMeta)}
      {...props}
    />
  )
}

export default SEO
